var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCameraIcon = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38889 0L7.58333 3.66667H3.25C1.4495 3.66667 0 5.13847 0 6.96667V18.7C0 20.5282 1.4495 22 3.25 22H22.75C24.5505 22 26 20.5282 26 18.7V6.96667C26 5.13847 24.5505 3.66667 22.75 3.66667H18.4167L16.6111 0H9.38889ZM13 7.7C15.7921 7.7 18.0556 9.99826 18.0556 12.8333C18.0556 15.6684 15.7921 17.9667 13 17.9667C10.208 17.9667 7.94444 15.6684 7.94444 12.8333C7.94444 9.99826 10.208 7.7 13 7.7Z",
    fill: "#03002F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCameraIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cameraIcon.1e4d36d7c93c73334f70c15e3a9dbb61.svg";